<template>
  <div class="w-100">
    <div class="styles-result-header">
      {{ $resourceString["site.search.collection.result.header"] }}
    </div>
    <div class="row w-100">
      <div class="col-2" v-for="collection in collections.slice(0, 4)"
           :key="collection.code"
           v-if="collection.itemsCount > 0">
        <div class="wf-search-result description search-collection-height w-100 p-0 mb-1">
          <div class="wf-search-result-top mb-0">
            <div class="wf-search-result-image-wrapper">
              <a class = "text-decoration-none"
                :href="$helpers.getCollectionOverviewUrl(getCollectionLink(collection))"
              >
                <wf-load-image :wrapperClass="'wf-search-result-image d-flex'"
                              :imageClass="'image full-image'"
                              :src="collection.imagePath != null ? collection.imagePath : ''"
                              :alt="collection.imagePathAltText || ''"
                              :noImageStyles="'no-image-style-block'" />
            </a>
            </div>
          </div>
          <ul class="styles-list">
            <li class="mb-0" v-html="$helpers.matchText(collection.name, searchTerm)"></li>
            <li>
              {{ collection.itemsCount }}
              {{ $resourceString["site.search.products.result.style.list"] }}
            </li>
          </ul>
          <div class="mt-auto pt-2">
            <a :href="$helpers.getCollectionOverviewUrl(getCollectionLink(collection))"
               class="view-styles-link">
              {{ $resourceString["site.search.products.result.see.collection"] }}
            </a>
            <Icon class="mb-1" icon="bx:bx-right-arrow-alt" width="15" />
          </div>
        </div>
      </div>
      <div class="col-2">
        <a :href="$helpers.getSearchTermUrl(searchTerm, 'collections')"
           v-if="collections.length > 4">
          <div class="view-more">
            <div class="view-more-text">
              {{ $resourceString["site.search.products.result.view.more"] }}
              <Icon class="pb-1 pl-1"
                    icon="fa-solid:plus"
                    color="white"
                    width="20" />
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import WFLoadImage from "../wf-load-image.vue";
  import { Icon } from "@iconify/vue2";

  export default {
    components: {
      "wf-load-image": WFLoadImage,
      Icon
    },
    props: ["collections"],
    computed: {
      ...mapGetters({
        searchTerm: "searchMenu/searchTerm"
      })
    },
    methods: {
      getCollectionLink(collection) {
        return collection.name.includes('&') ? collection.code : collection.name;
      }
    }
  };
</script>



